/* import __COLOCATED_TEMPLATE__ from './author.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */

import templateOnlyComponent from '@ember/component/template-only';
import type HelpCenterSite from 'embercom/models/help-center-site';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    site: HelpCenterSite;
    onToggle?: () => void;
  };
}

const Author = templateOnlyComponent<Signature>();
export default Author;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Articles::Site::Settings::Content::Author': typeof Author;
    'articles/site/settings/content/author': typeof Author;
  }
}
